import React from 'react';
import {createBrowserRouter, RouterProvider} from "react-router-dom"
import HomePage from './routes/HomePage';
import SubscribePage from './routes/SubscribePage';
import LoginPage from './routes/LoginPage';
import Auth from './components/Auth';

const App = () => {
  const router=createBrowserRouter([
    {
      path:"/",
      element:<SubscribePage />
    },
    {
      path:"/home",
      element:
      <Auth>
        <HomePage />
      </Auth>
    },
    {
      path:"/login",
      element:<LoginPage />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App